import "./index.css";
const links = {
  skool: "https://www.skool.com/radardigital/about",
  whatsapp: "https://chat.whatsapp.com/FaXwTNHKJaB44hVJYF7QmI",
  instagram: "https://www.instagram.com/marketingconmarcos/"
};
const steps = [{
  title: "Investigá la demanda",
  description: "Detectá problemas e ideas que las personas ya buscan resolver."
}, {
  title: "Modelá tu propuesta",
  description: "Analizá referencias para crear contenido propio, original y útil."
}, {
  title: "Creá tu ebook",
  description: "Organizá el contenido y apoyate en IA para producir y revisar tu producto."
}, {
  title: "Prepará tu oferta",
  description: "Definí qué recibe el comprador y por qué le sirve."
}, {
  title: "Armá tu página",
  description: "Prepará la página de ventas, el cobro y la entrega del ebook."
}, {
  title: "Atraé compradores",
  description: "Aprendé a crear contenido, creativos y campañas para dar a conocer tu oferta."
}];
const modules = [{
  title: "Bienvenida y primeros pasos",
  description: "Conocé la comunidad y organizá tu recorrido."
}, {
  title: "Investigación de producto",
  description: "Aprendé a investigar ideas de ebooks con demanda."
}, {
  title: "Modelar tu ebook",
  description: "Convertí tu investigación en un producto propio y original."
}, {
  title: "Páginas y entregables con IA",
  description: "Apoyate en Claude para crear y revisar tu ebook y página de ventas."
}, {
  title: "Hotmart",
  description: "Prepará tu producto, el cobro y la entrega para vender online."
}, {
  title: "Shopify",
  description: "Aprendé a configurar una tienda y el cobro con Mercado Pago en Argentina."
}, {
  title: "Creación de creativos",
  description: "Diseñá piezas para comunicar tu oferta y atraer compradores."
}, {
  title: "Facebook Ads",
  description: "Aprendé a configurar campañas, medir resultados y ajustar tu inversión."
}];
const cases = [{
  name: "Vilma · 65 años",
  result: "Su primera venta en menos de 15 días"
}, {
  name: "Leo",
  result: "Su primera venta en menos de 10 días"
}];
const faqs = [{
  question: "¿Necesito experiencia o un ebook para entrar?",
  answer: "No. La formación comienza con los primeros pasos y la investigación de ideas. Podés empezar sin un producto creado."
}, {
  question: "¿Cómo funcionan las asesorías?",
  answer: "Tenemos dos asesorías semanales con Marcos, los miércoles y viernes, para resolver dudas sobre el producto, la oferta y la venta. Consultá los horarios vigentes antes de suscribirte."
}, {
  question: "¿En cuánto tiempo puedo tener mi ebook listo?",
  answer: "Depende del tema, del alcance del producto y del tiempo que puedas dedicarle. No hay un plazo único ni una fecha garantizada para conseguir ventas."
}, {
  question: "¿Qué significa modelar un ebook?",
  answer: "Es investigar referencias y entender la demanda para crear una propuesta propia, original y útil. No se trata de copiar un ebook ajeno."
}, {
  question: "¿Hay otros costos además de la membresía?",
  answer: "Las herramientas y plataformas que elijas pueden tener suscripciones o comisiones propias. La inversión en anuncios tampoco está incluida."
}, {
  question: "¿Puedo entrar si vivo fuera de Argentina?",
  answer: "Podés conocer la comunidad y suscribirte desde Skool por USD 27 al mes. Los medios de cobro para tu propio ebook dependen de tu país."
}, {
  question: "¿Puedo cancelar la suscripción?",
  answer: "Sí. Gestionás la cancelación desde Skool. Al cancelar, dejás de renovar la membresía; revisá allí la fecha de finalización del período pagado."
}];
function Join({
  label = "Sumarme a Radar Digital"
}: {
  label?: string;
}) {
  return <a className="button" href={links.skool} target="_blank" rel="noopener noreferrer" data-id="element-0" data-mp="1i4ch7h5fgfvo">
      {label}
      <span aria-hidden="true" data-id="element-1" data-mp="1m44qxx6k4s2m">↗</span>
    </a>;
}
export function App() {
  return <>
      <header data-id="element-2" data-mp="6o5xzt5ih2my">
        <a className="brand" href="#inicio" data-id="element-3" data-mp="6ncqur2n4b4a">
          <b data-id="element-4" data-mp="6qs37m4xj620">r·</b>
          radar digital
          <small data-id="element-5" data-mp="aq992go9q57p">por Marcos Rosell</small>
        </a>

        <nav aria-label="Principal" data-id="element-6" data-mp="ano7ztvsntb0">
          <a href="#metodo" data-id="element-7" data-mp="qxf7hpbdb1hr">El método</a>
          <a href="#comunidad" data-id="element-8" data-mp="qyglo2nok43p">La comunidad</a>
          <a className="nav-cta" href="#unirme" data-id="element-9" data-mp="m5x7p4l2z6yd">
            Sumarme ↗
          </a>
        </nav>
      </header>

      <main data-id="element-10" data-mp="h6knkrllgdzh">
        <section id="inicio" className="hero shell" data-id="element-11" data-mp="h8414afv8axk">
          <div data-id="element-12" data-mp="c89dqgvau3h9">
            <p className="eyebrow" data-id="element-13" data-mp="c8rf1rwtj7w1">
              ● TU PRÓXIMO PROYECTO EMPIEZA ACÁ
            </p>

            <h1 data-id="element-14" data-mp="19wjdsqbiyh5q">
              Tu idea merece
              <br data-id="element-15" data-mp="19v8aerlzrbf5" />
              convertirse en
              <br data-id="element-16" data-mp="14weyh3mcrsh3" />
              <em data-id="element-17" data-mp="14xyect43k1ic">un ebook.</em>
            </h1>

            <p className="lead" data-id="element-18" data-mp="14v3vh60qeor1">
              Aprendé a crear tu propio producto digital y venderlo por
              internet. Con una ruta clara, una comunidad y Marcos
              acompañándote en cada paso.
            </p>

            <Join label="Empezar por USD 27/mes" data-id="element-19" data-mp="3koknrkkwrf2j" />

            <a className="method-link" href="#metodo" data-id="element-20" data-mp="3klydhd6mulgm">
              Conocer el método ↓
            </a>

            <p className="micro" data-id="element-21" data-mp="3gok49liycdom">
              Desde cero · Dos asesorías por semana · Comunidad en Skool
            </p>
          </div>

          <div className="visual" data-id="element-22" data-mp="205ieuxshylih">
            <img src="/Landing_Page_Hero_Color_Upgrade.png" alt="Marcos Rosell en moto en la montaña" width={1080} height={1080} data-id="element-23" data-mp="206jrv7t2pi2u" />

            <span className="photo-tag" data-id="element-24" data-mp="253abu6800xtj">
              UNA PERSONA REAL. UN PROYECTO PROPIO.
            </span>

            <div className="caption" data-id="element-25" data-mp="2ev6ja7vz60af">
              <small data-id="element-26" data-mp="2eu4uz1py7har">TU MENTOR</small>
              <strong data-id="element-27" data-mp="2ex97cmdkhjci">Marcos Rosell</strong>
              <span data-id="element-28" data-mp="2jt81kqlktvku">Papá, motero y emprendedor digital.</span>
            </div>

            <div className="session" data-id="element-29" data-mp="2nvuocd3e4qb6">
              <span aria-hidden="true" data-id="element-30" data-mp="2nww9jae4et6m">✳</span>
              <div data-id="element-31" data-mp="2supddwrybb3q">
                <strong data-id="element-32" data-mp="2sv7jdl4f13ou">Avanzá acompañado</strong>
                <small data-id="element-33" data-mp="2stwe1gvbnnvm">Asesorías los miércoles y viernes</small>
              </div>
            </div>
          </div>
        </section>

        <div className="strip" data-id="element-34" data-mp="ygepbqj6kkz0">
          <div className="shell" data-id="element-35" data-mp="yhpspp8prqpl">
            <span data-id="element-36" data-mp="yir640d7cpah">UN MÉTODO, PASO A PASO</span>
            <span data-id="element-37" data-mp="21qsjgb7642hs">FORMACIÓN A TU RITMO</span>
            <span data-id="element-38" data-mp="21ru6zf5dehge">2 ASESORÍAS SEMANALES</span>
            <span data-id="element-39" data-mp="1wt0sbjeckken">COMUNIDAD EN SKOOL</span>
          </div>
        </div>

        <section className="shell section" data-id="element-40" data-mp="1wuu237k9bkqv">
          <p className="eyebrow" data-id="element-41" data-mp="2atbjyonhe30v">01 / DE MIRAR A HACER</p>

          <div className="split" data-id="element-42" data-mp="25t5nmv69nscg">
            <h2 data-id="element-43" data-mp="25sw67vzaetid">
              No te faltan ideas.
              <br data-id="element-44" data-mp="25vifq15qnj38" />
              Te falta <em data-id="element-45" data-mp="2kpwq5db8lk6a">una dirección.</em>
            </h2>

            <div data-id="element-46" data-mp="2kolphmd38sje">
              <p data-id="element-47" data-mp="2ko3ipvssuvx8">
                Ya viste videos sobre ebooks, inteligencia artificial y
                negocios digitales. Pero cuando te sentás a hacerlo,
                aparecen las dudas: qué vender, cómo crearlo y dónde empezar.
              </p>
              <p className="bright" data-id="element-48" data-mp="2pig4ichr0jc5">
                En Radar Digital transformás esas dudas en pasos concretos,
                con formación y encuentros para resolver lo que te frena.
              </p>
            </div>
          </div>
        </section>

        <section className="method section" id="metodo" data-id="element-49" data-mp="3i3mu2ipdol3m">
          <div className="shell" data-id="element-50" data-mp="3i463fb0yq161">
            <div className="heading" data-id="element-51" data-mp="3n2pq5dndrgzg">
              <div data-id="element-52" data-mp="3n1oeb6yjiqgo">
                <p className="eyebrow" data-id="element-53" data-mp="3n27n9y67q4ik">02 / TU HOJA DE RUTA</p>
                <h2 data-id="element-54" data-mp="385ysp9x9ofch">
                  De una idea a una oferta
                  <br data-id="element-55" data-mp="387t9qd5f3nba" />
                  <em data-id="element-56" data-mp="3d40jyi4ujkz1">lista para vender.</em>
                </h2>
              </div>

              <p data-id="element-57" data-mp="2zd57ywz1wnr8">
                No necesitás tener un ebook ni experiencia.
                <br data-id="element-58" data-mp="2zb27tk46pe8s" />
                Necesitás empezar por el primer paso.
              </p>
            </div>

            <ol className="steps" data-id="element-59" data-mp="345oh9hqpgwq8">
              {steps.map((step, index) => <li key={step.title} data-id="element-60" data-mp="2pgin486q5wp7" data-mpi={index}>
                  <small data-id="element-61" data-mp="2ue20z6zig7gm">0{index + 1}</small>
                  <span className="card-arrow" aria-hidden="true" data-id="element-62" data-mp="2uf3le22f26b0">
                    ↗
                  </span>
                  <h3 data-id="element-63" data-mp="2gesvb18xkvqw">{step.title}</h3>
                  <p data-id="element-64" data-mp="2kfuwvoqbljw1">{step.description}</p>
                </li>)}
            </ol>
          </div>
        </section>

        <section className="shell section" id="comunidad" data-id="element-65" data-mp="30v3s4getyhw9">
          <div className="community split" data-id="element-66" data-mp="30ulwnlzzs7pe">
            <div data-id="element-67" data-mp="2vvr8e4j99qxw">
              <p className="eyebrow" data-id="element-68" data-mp="2vxc3bv9hfbwa">03 / CERCA, EN CADA PASO</p>
              <h2 data-id="element-69" data-mp="2qwxrs38o9jti">
                Un curso te enseña.
                <br data-id="element-70" data-mp="2qvmos5n1wg3g" />
                Una comunidad
                <br data-id="element-71" data-mp="2lymhxsidn9ba" />
                <em data-id="element-72" data-mp="2lx32230mv0a1">te acompaña.</em>
              </h2>

              <p data-id="element-73" data-mp="2hwj4iyc5dund">
                Traé tus dudas sobre el ebook, la oferta o la venta.
                Trabajamos sobre lo que necesitás para avanzar con tu
                propio proyecto.
              </p>

              <Join label="Conocer Radar Digital" data-id="element-74" data-mp="286ge95weuusq" />
            </div>

            <div data-id="element-75" data-mp="284lrdm1kwsm0">
              <div className="live" data-id="element-76" data-mp="237mzla5e0xqz">
                <small data-id="element-77" data-mp="238ob1fqbfm98">TU PUNTO DE ENCUENTRO</small>

                <h3 data-id="element-78" data-mp="235se9uq7f3md">
                  Dos asesorías.
                  <br data-id="element-79" data-mp="1y78p7lgbdbps" />
                  Cada semana.
                </h3>

                <div className="days" data-id="element-80" data-mp="1u6f40zu9ab0l">
                  <span data-id="element-81" data-mp="1u7gmhpdlpzsc">Miércoles</span>
                  <span data-id="element-82" data-mp="9owcy835g0kf">Viernes</span>
                </div>

                <p data-id="element-83" data-mp="9omo4ntubzgb">
                  Con Marcos, para resolver dudas sobre tu producto,
                  oferta y venta.
                </p>
              </div>

              <div className="mini-card" data-id="element-84" data-mp="ipb4hp6pibwd">
                <b aria-hidden="true" data-id="element-85" data-mp="iqdvry7xygct">◎</b>
                <div data-id="element-86" data-mp="np78hofem3bx">
                  <h3 data-id="element-87" data-mp="nnmdjxp6gidj">Tu comunidad en Skool</h3>
                  <p data-id="element-88" data-mp="nmb87tg332kb">
                    Compartí el proceso con personas que también están
                    creando su producto digital.
                  </p>
                </div>
              </div>

              <div className="mini-card" data-id="element-89" data-mp="3w4h5wj8cmkdd">
                <b aria-hidden="true" data-id="element-90" data-mp="3w3fsi83v1lsh">▤</b>
                <div data-id="element-91" data-mp="3w2e8vf8s3qz5">
                  <h3 data-id="element-92" data-mp="4pjip29y7r7t">Formación a tu ritmo</h3>
                  <p data-id="element-93" data-mp="4re3mgl7zjbw">
                    Una ruta para investigar, crear y preparar la venta
                    de tu ebook.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="shell section program" id="programa" data-id="element-94" data-mp="2f758uxzgc1d3">
          <div className="heading" data-id="element-95" data-mp="2f6lsvmtd3n1p">
            <div data-id="element-96" data-mp="2k681fiy8wf46">
              <p className="eyebrow" data-id="element-97" data-mp="2k5ot8tyed53c">04 / LO QUE VAS A APRENDER</p>
              <h2 data-id="element-98" data-mp="2k81d5cnptpj1">
                Las piezas de
                <br data-id="element-99" data-mp="2p6cltk29xtzo" />
                <em data-id="element-100" data-mp="2p5ujc5p0qjjb">tu próximo proyecto.</em>
              </h2>
            </div>

            <p data-id="element-101" data-mp="2u330c2yfkhiz">
              De la investigación a los anuncios.
              <br data-id="element-102" data-mp="1wgvsmk6ty92e" />
              Cada módulo tiene un propósito.
            </p>
          </div>

          <div className="modules" data-id="element-103" data-mp="21fgvkrdgv6uj">
            {modules.map((module, index) => <article key={module.title} data-id="element-104" data-mp="21dmczjpo3qtm" data-mpi={index}>
                <small data-id="element-105" data-mp="26ejqvk3n9ypb">MÓDULO 0{index + 1}</small>
                <h3 data-id="element-106" data-mp="26cqio0ddv6f7">{module.title}</h3>
                <p data-id="element-107" data-mp="2b61teclbg7ce">{module.description}</p>
              </article>)}
          </div>
        </section>

        <section className="results section" data-id="element-108" data-mp="1dqnxao9dgmwr">
          <div className="shell" data-id="element-109" data-mp="1dpw0ja41gj4w">
            <p className="eyebrow" data-id="element-110" data-mp="1ip8xwosjd8lq">05 / PRIMEROS PASOS REALES</p>

            <h2 data-id="element-111" data-mp="1inee5dt03mj8">
              Ellos también
              <br data-id="element-112" data-mp="3w00mfj8jtg6c" />
              <em data-id="element-113" data-mp="3vyh4zpb5oz2z">empezaron desde cero.</em>
            </h2>

            <div className="cases" data-id="element-114" data-mp="3rxx7ulql1vgu">
              {cases.map(item => <article key={item.name} data-id="element-115" data-mp="3ryf2jdxlk1mn">
                  <span className="quote" aria-hidden="true" data-id="element-116" data-mp="3myu0uvr1lf68">
                    “
                  </span>
                  <h3 data-id="element-117" data-mp="3hzzke0gjs2pa">{item.result}</h3>
                  <p data-id="element-118" data-mp="3hyxyt21wnxtb">{item.name}</p>
                  <small data-id="element-119" data-mp="3i23mqdysstng">EXPERIENCIA DE ALUMNO</small>
                </article>)}
            </div>

            <p className="micro" data-id="element-120" data-mp="3d2hb28ymblgr">
              Experiencias individuales. Los resultados y tiempos
              dependen de la implementación, la propuesta y la demanda.
            </p>
          </div>
        </section>

        <section className="shell section" data-id="element-121" data-mp="2z9hv65uxbp8o">
          <p className="eyebrow" data-id="element-122" data-mp="2zajawnmvwzwq">
            06 / QUIÉN ESTÁ DEL OTRO LADO
          </p>

          <div className="split" data-id="element-123" data-mp="2u8tv6uopvy2b">
            <h2 data-id="element-124" data-mp="2uc99hvakh32o">
              Soy Marcos.
              <br data-id="element-125" data-mp="2pasbq8ndpwqb" />
              Y también tuve que
              <br data-id="element-126" data-mp="2pd51v93ajdeg" />
              <em data-id="element-127" data-mp="2fng1szbdv4q7">empezar de cero.</em>
            </h2>

            <div data-id="element-128" data-mp="2flv799p2jlsc">
              <p data-id="element-129" data-mp="2fpj2cda5wg96">
                Soy papá de dos nenas y me apasionan las motos.
                Compartir tiempo con mi familia es parte de por qué
                elegí emprender por internet.
              </p>

              <p data-id="element-130" data-mp="2aod6i6l7gcvf">
                Hoy comparto lo que aprendí para ayudarte a crear tu
                producto, preparar tu oferta y dar tus primeros pasos
                en la venta online.
              </p>

              <p className="signature" data-id="element-131" data-mp="33cr6uszrnla5">
                Marcos Rosell
                <small data-id="element-132" data-mp="33f4wunfla7au">Fundador de Radar Digital</small>
              </p>
            </div>
          </div>
        </section>

        <section className="shell section offer split" id="unirme" data-id="element-133" data-mp="2tn7ij7taaz7w">
          <div data-id="element-134" data-mp="2tleapp6xq8yb">
            <p className="eyebrow" data-id="element-135" data-mp="2tkuvig8o5ynz">
              07 / HACÉ LUGAR A TU PROYECTO
            </p>

            <h2 data-id="element-136" data-mp="3hayvmdmnfga8">
              El próximo paso
              <br data-id="element-137" data-mp="3m4jxigrd4uep" />
              puede ser <em data-id="element-138" data-mp="3m4tg3ja2vzad">tuyo.</em>
            </h2>

            <p data-id="element-139" data-mp="1ao1auzr1v48y">
              Sumate a Radar Digital y empezá a trabajar en tu propio
              ebook, con una ruta y acompañamiento.
            </p>

            <ul className="included" data-id="element-140" data-mp="15p6k9bmucbea">
              <li data-id="element-141" data-mp="1ke2zptr88qox">Formación para crear y vender ebooks</li>
              <li data-id="element-142" data-mp="1kdksy36xuu2r">Dos asesorías semanales con Marcos</li>
              <li data-id="element-143" data-mp="1fezuo9b8ykgy">Comunidad privada en Skool</li>
            </ul>
          </div>

          <div className="price-card" data-id="element-144" data-mp="rpf7fe82911v">
            <span className="badge" data-id="element-145" data-mp="rqgobzbrchri">
              MEMBRESÍA · PRECIO FUNDADOR
            </span>

            <h3 data-id="element-146" data-mp="mrvt6ebd4o9x">Todo en un solo lugar.</h3>

            <p className="price" data-id="element-147" data-mp="11nv0hmqneke0">
              USD 27<small data-id="element-148" data-mp="11owbjr7nz6vq">/mes</small>
            </p>

            <p className="price-description" data-id="element-149" data-mp="11libwqqdxbrz">
              Formación + comunidad + acompañamiento
            </p>

            <Join data-id="element-150" data-mp="2d2rrh26e7jo0" />

            <p className="micro" data-id="element-151" data-mp="2d28k2fedcdo8">
              El enlace abre la comunidad en Skool.
            </p>

            <div className="billing" data-id="element-152" data-mp="284qd2ujww8iv">
              Renovación mensual automática.
              <br data-id="element-153" data-mp="hncx2vjlpuq7" />
              Podés cancelar desde Skool.
            </div>
          </div>
        </section>

        <section className="shell section faq split" data-id="element-154" data-mp="ml4qjtzw9owi">
          <div data-id="element-155" data-mp="mnr6oi0upcqc">
            <p className="eyebrow" data-id="element-156" data-mp="qnrkq1k1flwv">
              08 / RESOLVAMOS TUS DUDAS
            </p>

            <h2 data-id="element-157" data-mp="vml1c2umft19">
              Antes de
              <br data-id="element-158" data-mp="vnnn5wd375ab" />
              <em data-id="element-159" data-mp="vo5tjltgqzvy">dar el paso.</em>
            </h2>
          </div>

          <div data-id="element-160" data-mp="10mh2lubxp6d4">
            {faqs.map(faq => <details key={faq.question} data-id="element-161" data-mp="10lfg8tpgwxg3">
                <summary data-id="element-162" data-mp="15kioso4nplst">
                  {faq.question}
                  <span aria-hidden="true" data-id="element-163" data-mp="15ixu8yice2uy">+</span>
                </summary>
                <p data-id="element-164" data-mp="1acs8vnj3brn6">{faq.answer}</p>
              </details>)}
          </div>
        </section>

        <section className="shell closing" data-id="element-165" data-mp="1ec12mse4rpiq">
          <p className="eyebrow" data-id="element-166" data-mp="1eex06fm2gc6n">
            TU IDEA NO TIENE QUE QUEDARSE EN UNA IDEA.
          </p>

          <h2 data-id="element-167" data-mp="1jacc320ijy0f">
            Empezá a darle <em data-id="element-168" data-mp="1oaqi6eik0xvt">forma.</em>
          </h2>

          <Join label="Empezar por USD 27/mes" data-id="element-169" data-mp="1objjv12nox73" />

          <p className="whatsapp" data-id="element-170" data-mp="1yfq7e07mbv21">
            ¿Todavía tenés dudas?{" "}
            <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" data-id="element-171" data-mp="1ycubehfbzgg8">
              Sumate al grupo gratuito de WhatsApp ↗
            </a>
          </p>
        </section>
      </main>

      <footer className="shell" data-id="element-172" data-mp="1oiu88l3m0la5">
        <a className="brand" href="#inicio" data-id="element-173" data-mp="1kfxhg73x1iv4">
          <b data-id="element-174" data-mp="1kh8nkdku32pe">r·</b>
          radar digital
        </a>

        <span data-id="element-175" data-mp="2h67zc2kmmmmc">© 2026 Marketing con Marcos</span>

        <a href={links.instagram} target="_blank" rel="noopener noreferrer" data-id="element-176" data-mp="2h4wwq62x3kwt">
          @marketingconmarcos ↗
        </a>
      </footer>
    </>;
}